<template>
  <div
    v-if="!isNative"
    class="row q-px-md justify-center"
    :class="backgroundColor == null ? (isMobileView? 'q-pt-lg bg-dark' : 'q-pt-xl bg-dark') : (isMobileView ? 'q-pt-lg' : 'q-pt-xl') "
    data-test-id="consumer-footer"
  >
    <div
      class="row justify-between container"
      :class="footerDarkMode ? 'text-white': 'text-dark'"
    >
      <div
        v-if="showLogo"
        class="col-12"
        :class="containerClass"
      >
        <img
          v-if="footerDarkMode"
          alt="Logo"
          :src="currentSite.lightLogoMarkImageUrl"
          class="full-width"
          style="max-width: 150px;"
        >
        <img
          v-else
          alt="Logo"
          :src="currentSite.darkLogoMarkImageUrl"
          class="full-width"
          style="max-width: 150px;"
        >
      </div>
      <div
        v-if="showContactInfo"
        class="col-12"
        :class="containerClass"
      >
        <div class="text-h5">
          {{ currentSite.name }}
        </div>
        <div class="text-body">
          {{ currentSite.address1 }}
        </div>
        <div class="text-body">
          {{ currentSite.city }}, {{ currentSite.state }} {{ currentSite.zip }}
        </div>
        <div
          v-if="currentSite.phone && !currentSite.consumerConfig.hidePhone"
          class="text-body"
        >
          {{ currentSite.phone }}
        </div>
        <div
          v-if="currentSite.email && !currentSite.consumerConfig.hideEmail"
          class="text-body footer-site-email"
        >
          {{ currentSite.email }}
        </div>
        <social-icons
          v-if="showSocialIcons"
          class="row"
          :class="isMobileView ? 'justify-center q-gutter-md q-pt-sm' : 'q-gutter-lg q-pt-md'"
          :social-icons-color="socialIconsColor"
          icon-size="24px"
        />
      </div>
      <div
        v-if="showMainLinks"
        class="col-12"
        :class="isMobileView ? 'text-center q-mt-lg' : 'col-sm-auto'"
      >
        <div class="text-h5">
          {{ currentSite.movieIdentifierText }}
        </div>
        <router-link
          class="nav-link"
          to="/"
        >
          {{ currentSite.movieNowPlayingText }}
        </router-link>
        <router-link
          class="nav-link"
          :to="currentSite.defaultExploreRoute"
        >
          {{ $t('nav.actions.exploreThing', { thing: currentSite.movieIdentifierText }) }}
        </router-link>
      </div>
      <div
        v-if="showMoreLinks"
        class="col-12"
        :class="isMobileView ? 'text-center q-mt-lg' : 'col-sm-auto'"
      >
        <div class="text-h5">
          {{ $t('nav.moreInformation') }}
        </div>
        <a
          v-for="navLink in footerNavigations"
          :key="navLink.id"
          class="nav-link cursor-pointer"
          @click="navLink.navigateToRedirect($router)"
        >
          {{ navLink.title }}
        </a>
        <consumer-footer-edit-menu
          v-if="currentUser && currentUser.admin"
          @edit-navigations="$emit('edit-navigations')"
          @time-travel="$emit('time-travel')"
        />
      </div>
    </div>
    <div
      class="row justify-between container"
      :class="footerDarkMode ? 'text-white': 'text-dark'"
    >
      <div
        class="col-auto"
        :class="isMobileView ? 'text-center q-mt-xl' : 'text-left q-mt-xl'"
      >
        <p>© Copyright {{ new Date().getFullYear() }} {{ copyRightName }}. All rights reserved.</p>
      </div>
      <div
        class="col-auto"
        :class="isMobileView ? 'text-center full-width' : 'text-right q-mt-xl'"
      >
        <p>Shaped by INDY</p>
      </div>
    </div>
  </div>
</template>

<script>
import { isNative } from 'src/config'
import SocialIcons from 'src/modules/consumer/components/SocialIcons'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'ConsumerFooter',
  components: {
    SocialIcons,
    ConsumerFooterEditMenu: defineAsyncComponent(() => import('src/modules/consumer/components/ConsumerFooterEditMenu'))
  },
  props: {
    showLogo: {
      type: Boolean,
      required: false,
      default: true
    },
    showContactInfo: {
      type: Boolean,
      required: false,
      default: true
    },
    showMainLinks: {
      type: Boolean,
      required: false,
      default: true
    },
    showMoreLinks: {
      type: Boolean,
      required: false,
      default: true
    },
    backgroundColor: {
      type: String,
      required: false,
      default: null
    },
    footerDarkMode: {
      type: Boolean,
      required: false,
      default: true
    },
    showSocialIcons: {
      type: Boolean,
      required: false,
      default: true
    },
    socialIconsColor: {
      type: String,
      required: false,
      default: 'full'
    },
    showCircuitNameInFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    verticalAlignTop: {
      type: Boolean,
      required: false,
      default: false
    },
    isPhonePreview: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobileView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['edit-navigations', 'time-travel'],

  data () {
    return {
      lastViewedNewsAt: null
    }
  },

  context: ['currentUser'],
  configuration: ['currentSite', 'publishedNewsItems', 'navigations', 'currentCircuit'],

  computed: {
    isNative () {
      return isNative
    },
    footerNavigations () {
      return _.filter(this.navigations?.data, navigation => navigation.showInFooter && !navigation.isArchived)
    },
    containerClass () {
      if (this.verticalAlignTop) {
        return this.isMobileView ? 'text-center q-mt-lg' : 'col-sm-auto'
      }
      return this.isMobileView ? 'self-center text-center q-mt-lg' : 'self-center col-sm-auto'
    },
    copyRightName () {
      return this.showCircuitNameInFooter ? this.currentCircuit.name : this.currentSite.name
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-link {
    display: block;
    color: inherit;
    text-decoration: none;
  }
</style>
